import React from 'react'

import { Heading4 } from '@gousto-internal/citrus-react'

import css from './HeadingWithSeparator.css'

export const HeadingWithSeparator = ({ children }: { children: React.ReactNode }) => (
  <div data-testid="heading-with-separator">
    <div data-testid="heading-container" className={css.heading}>
      <Heading4>{children}</Heading4>
    </div>
    <div className={css.line} />
  </div>
)
